import React from "react";
import { FaBan, FaCalendarCheck, FaUtensils } from "react-icons/fa";
import { hubwayzRoomCardCopy } from "./hubwayzRoomCardCopy";

/**
 * Board and cancellation as separate rows. Does not render the gray
 * "board · capacity" note.
 */
export default function HubwayzRoomCardFacts({ room }) {
  const copy = hubwayzRoomCardCopy(room);
  if (!copy.board && !copy.cancellation) return null;

  return (
    <div className="usm-fh-room-facts" dir="rtl">
      {copy.board ? (
        <div
          className={`usm-fh-room-fact usm-fh-room-fact--board${
            copy.boardWarn ? " usm-fh-room-fact--warn" : ""
          }`}
        >
          <FaUtensils aria-hidden />
          <span>
            <span className="usm-fh-room-fact__label">בסיס אירוח</span>
            <span className="usm-fh-room-fact__value">{copy.board}</span>
          </span>
        </div>
      ) : null}
      {copy.cancellation ? (
        <div
          className={`usm-fh-room-fact usm-fh-room-fact--cancel${
            copy.cancellationWarn ? " usm-fh-room-fact--warn" : ""
          }`}
        >
          {copy.cancellationWarn ? (
            <FaBan aria-hidden />
          ) : (
            <FaCalendarCheck aria-hidden />
          )}
          <span>
            <span className="usm-fh-room-fact__label">תנאי ביטול</span>
            <span className="usm-fh-room-fact__value">{copy.cancellation}</span>
          </span>
        </div>
      ) : null}
    </div>
  );
}
